import { FC } from 'react'

import { PageTitle, StandardLayout } from '@sequencehq/core-components'

import { useProduct } from 'Products/hooks/useProduct'

export const HeaderBreadcrumbs: FC = () => {
  const { product } = useProduct()

  const productTitle = product?.name || 'Product'

  return (
    <>
      <PageTitle title={[productTitle, 'Products']} />
      <StandardLayout.Breadcrumbs>
        <StandardLayout.Breadcrumbs.Breadcrumb href="/products">
          Products
        </StandardLayout.Breadcrumbs.Breadcrumb>
        <StandardLayout.Breadcrumbs.Breadcrumb>
          {productTitle}
        </StandardLayout.Breadcrumbs.Breadcrumb>
      </StandardLayout.Breadcrumbs>
    </>
  )
}
